<template>
  <div class="full-offer-wrapper">
    <div data-simplebar>
      <div class="simplebar-scroll-content">
        <div class="simplebar-content">
          <table>
            <tbody>
            <tr v-for="(value, key) in searchedOffer"
                v-bind:key="key"
                @click="addMatch(key)">
              <td class="match-id">{{value.matchDisplayId}}</td>
              <td class="game-icon">
                <i class="n-i" v-bind:class="[getIcon]"></i>
              </td>
              <td class="match-name">{{value.matchName}}</td>
              <td class="match-time">{{value.matchDateTimeUTC | formatDate}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import toNumber from 'lodash/toNumber';

export default {
  name: 'FullOfferBox',
  data() {
    return {
      searchedOffer: {},
    };
  },
  computed: {
    ...mapGetters([
      'offer',
      'gameId',
      'getIcon',
      'searchedValue',
    ]),
  },
  methods: {
    ...mapActions([
      'updateSelected',
      'setSearchedValue',
      'setSearchInputActive',
    ]),
    /**
     * Redirect to selected match
     *
     * @param {number} id
     */
    addMatch(id) {
      const selected = {
        match: this.offer[id],
        bet: {},
        outcome: {},
      };
      this.updateSelected(selected);
      this.$router.push({ path: '/betoffer' });
    },
    /**
     * Search matches by match id and name
     *
     * @param {string} data
     */
    searchOffer(data) {
      const offerKeys = Object.keys(this.offer);
      const newOffer = {};
      const value = toNumber(data);
      let i = 0;
      let index;
      while (i < offerKeys.length && data) {
        if (!Number.isNaN(value)) {
          const idToString = this.offer[offerKeys[i]].idMatch.toString();
          index = idToString.indexOf(value);
          if (index >= 0) {
            newOffer[offerKeys[i]] = this.offer[offerKeys[i]];
          }
        } else {
          index = (this.offer[offerKeys[i]].matchName.toLowerCase()).indexOf(data.toLowerCase());
          if (index >= 0) {
            newOffer[offerKeys[i]] = this.offer[offerKeys[i]];
          }
        }
        i += 1;
      }
      this.searchedOffer = Object.keys(newOffer).length ? newOffer : this.offer;
    },
  },
  mounted() {
    this.setSearchInputActive();
    this.searchedOffer = this.offer;
  },
  watch: {
    searchedValue: {
      handler(newValue) {
        this.searchOffer(newValue);
      },
    },
    offer: {
      handler() {
        this.searchOffer(this.searchedValue);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.full-offer-wrapper {
  height: 100%;
  padding: 10px 0 10px 10px;
}
table {
  border-collapse: collapse;
  width: 100%;
  tr {
    -webkit-box-shadow: inset 0px -1px 0 0 rgba(210, 213, 214, 0.49);
    -moz-box-shadow: inset 0px -1px 0 0 rgba(210, 213, 214, 0.49);
    box-shadow: inset 0px -1px 0 0 rgba(210, 213, 214, 0.49);
    line-height: 1.3rem;
    &:hover {
      background: #e0e0e0;
    }
    td {
      padding: 9px 10px;
      text-align: center;
      &.match-id {
        width: 10%;
      }
      &.game-icon {
        font-size: 14px;
        width: 6%;
      }
      &.match-name {
        text-align: left !important;
      }
      &.match-time {
        padding-right: 20px;
        text-align: right !important;
      }
    }
  }
}
</style>
